/**
 * Created by shaun on 16/09/2017.
 */

import {EMPTY, LOADING, READY, ERROR} from 'module/constants';
import common from 'module/common';

const SET_STATE = 'state';
const SET_BRANDS = 'setBrands';
const SET_SELECTED = 'setSelected';

// initial state
const state = {
  state: EMPTY,
  brands: [],
  selected: {
    name: null,
    label: null,
    title: null,
    logo: null,
    branches: [],
    prices: null,
  }
};

//actions
const actions = {
  load({state, dispatch, commit, rootGetters}) {
    if(['portal'].includes(rootGetters['environment/route']) === false){
      //Not needed for this environment
      return;
    }

    commit(SET_STATE, LOADING);

    let idToken = rootGetters['user/idToken']();

    common
      .httpGet('brand')
      .idToken(idToken || null)
      .then((res) => {
        commit(SET_STATE, READY);
        commit(SET_BRANDS, res.data);

        if (state.selected.name !== null) {
          dispatch('selectBrand', state.selected.name)
        }

      }, ({data}) => {
        commit(SET_STATE, ERROR);
      });
  },
  selectBrand({state, commit}, brandName) {
    let brand = state.brands.filter(m => m.name === brandName);

    if (brand.length >= 1) {
      commit(SET_SELECTED, brand[0]);
    } else if (state.state === LOADING) {
      //set brand name if still loading
      let brand = _.cloneDeep(state.selected);
      brand.name = brandName;
      commit(SET_SELECTED, brand);
    }
  }
};

//getters
const getters = {};

// mutations
const mutations = {
  [SET_STATE](state, newState) {
    state.state = newState;
  },
  [SET_BRANDS](state, brands) {
    state.brands = brands;
  },
  [SET_SELECTED](state, brand) {
    state.selected.name = brand.name;
    state.selected.label = brand.label;
    state.selected.logo = require(`img/brand/${brand.name}.png`);
    state.selected.title = brand.title || null;
    state.selected.branches = brand.branches || [];
    state.selected.prices = brand.prices || null;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}